export var da;
(function (da) {
    da.names = {
        AF: "Afghanistan",
        AL: "Albanien",
        DZ: "Algeriet",
        AS: "Amerikansk Samoa",
        AD: "Andorra",
        AO: "Angola",
        AI: "Anguilla",
        AQ: "Antarktis",
        AG: "Antigua og Barbuda",
        AR: "Argentina",
        AM: "Armenien",
        AW: "Aruba",
        AU: "Australien",
        AT: "Østrig",
        AZ: "Aserbajdsjan",
        BS: "Bahamas",
        BH: "Bahrain",
        BD: "Bangladesh",
        BB: "Barbados",
        BY: "Hviderusland",
        BE: "Belgien",
        BZ: "Belize",
        BJ: "Benin",
        BM: "Bermuda",
        BT: "Bhutan",
        BO: "Bolivia",
        BA: "Bosnien-Hercegovina",
        BW: "Botswana",
        BV: "Bouvet Island",
        BR: "Brasilien",
        IO: "British Indian Ocean Territory",
        BN: "Brunei Darussalam",
        BG: "Bulgarien",
        BF: "Burkina Faso",
        BI: "Burundi",
        KH: "Cambodja",
        CM: "Cameroun",
        CA: "Canada",
        CV: "Kap Verde",
        KY: "Caymanøerne",
        CF: "Den Centralafrikanske Republik",
        TD: "Tchad",
        CL: "Chile",
        CN: "Kina",
        CX: "Juløen",
        CC: "Cocosøerne",
        CO: "Colombia",
        KM: "Comorerne",
        CG: "Congo",
        CD: "Demokratiske Republik Congo",
        CK: "Cookøerne",
        CR: "Costa Rica",
        CI: "Elfenbenskysten",
        HR: "Kroatien",
        CU: "Cuba",
        CY: "Cypern",
        CZ: "Tjekkiet",
        DK: "Danmark",
        DJ: "Djibouti",
        DM: "Dominica",
        DO: "Dominikanske Republik",
        EC: "Ecuador",
        EG: "Egypten",
        SV: "El Salvador",
        GQ: "Ækvatorialguinea",
        ER: "Eritrea",
        EE: "Estland",
        ET: "Etiopien",
        FK: "Falklandsøerne",
        FO: "Færøerne",
        FJ: "Fiji",
        FI: "Finland",
        FR: "Frankrig",
        GF: "Fransk Guiana",
        PF: "Fransk Polynesien",
        TF: "Franske Sydterritorier",
        GA: "Gabon",
        GM: "Gambia",
        GE: "Georgien",
        DE: "Tyskland",
        GH: "Ghana",
        GI: "Gibraltar",
        GR: "Grækenland",
        GL: "Grønland",
        GD: "Grenada",
        GP: "Guadeloupe",
        GU: "Guam",
        GT: "Guatemala",
        GN: "Guinea",
        GW: "Guinea-Bissau",
        GY: "Guyana",
        HT: "Haiti",
        HM: "Heard-øen og McDonald-øerne",
        VA: "Vatikanstaten",
        HN: "Honduras",
        HK: "Hong Kong",
        HU: "Ungarn",
        IS: "Island",
        IN: "Indien",
        ID: "Indonesien",
        IR: "Iran",
        IQ: "Irak",
        IE: "Irland",
        IL: "Israel",
        IT: "Italien",
        JM: "Jamaica",
        JP: "Japan",
        JO: "Jordan",
        KZ: "Kazakhstan",
        KE: "Kenya",
        KI: "Kiribati",
        KP: "Nordkorea",
        KR: "Sydkorea",
        KW: "Kuwait",
        KG: "Kirgisistan",
        LA: "Laos",
        LV: "Letland",
        LB: "Libanon",
        LS: "Lesotho",
        LR: "Liberia",
        LY: "Libyen",
        LI: "Liechtenstein",
        LT: "Litauen",
        LU: "Luxembourg",
        MO: "Macao",
        MK: "Makedonien",
        MG: "Madagaskar",
        MW: "Malawi",
        MY: "Malaysia",
        MV: "Maldiverne",
        ML: "Mali",
        MT: "Malta",
        MH: "Marshalløerne",
        MQ: "Martinique",
        MR: "Mauretanien",
        MU: "Mauritius",
        YT: "Mayotte",
        MX: "Mexico",
        FM: "Mikronesien",
        MD: "Moldova",
        MC: "Monaco",
        MN: "Mongoliet",
        MS: "Montserrat",
        MA: "Marokko",
        MZ: "Mozambique",
        MM: "Myanmar (Burma)",
        NA: "Namibia",
        NR: "Nauru",
        NP: "Nepal",
        NL: "Holland",
        NC: "Ny Kaledonien",
        NZ: "New Zealand",
        NI: "Nicaragua",
        NE: "Niger",
        NG: "Nigeria",
        NU: "Niue",
        NF: "Norfolk Island",
        MP: "Nordmarianerne",
        NO: "Norge",
        OM: "Oman",
        PK: "Pakistan",
        PW: "Palau",
        PS: "Palæstina",
        PA: "Panama",
        PG: "Papua Ny Guinea",
        PY: "Paraguay",
        PE: "Peru",
        PH: "Filippinerne",
        PN: "Pitcairn",
        PL: "Polen",
        PT: "Portugal",
        PR: "Puerto Rico",
        QA: "Qatar",
        RE: "Réunion",
        RO: "Rumænien",
        RU: "Rusland",
        RW: "Rwanda",
        SH: "Sankt Helena",
        KN: "Saint Kitts og Nevis",
        LC: "Saint Lucia",
        PM: "Saint-Pierre og Miquelon",
        VC: "Saint Vincent og Grenadinerne",
        WS: "Samoa",
        SM: "San Marino",
        ST: "São Tomé og Príncipe",
        SA: "Saudi-Arabien",
        SN: "Senegal",
        SC: "Seychellerne",
        SL: "Sierra Leone",
        SG: "Singapore",
        SK: "Slovakiet",
        SI: "Slovenien",
        SB: "Salomonøerne",
        SO: "Somalia",
        ZA: "Sydafrika",
        GS: "South Georgia og South Sandwich Islands",
        ES: "Spanien",
        LK: "Sri Lanka",
        SD: "Sudan",
        SR: "Surinam",
        SJ: "Norge Svalbard og Jan Mayen",
        SZ: "Swaziland",
        SE: "Sverige",
        CH: "Schweiz",
        SY: "Syrien",
        TW: "Republikken Kina Taiwan",
        TJ: "Tadsjikistan",
        TZ: "Tanzania",
        TH: "Thailand",
        TL: "Østtimor",
        TG: "Togo",
        TK: "Tokelau",
        TO: "Tonga",
        TT: "Trinidad og Tobago",
        TN: "Tunesien",
        TR: "Tyrkiet",
        TM: "Turkmenistan",
        TC: "Turks- og Caicosøerne",
        TV: "Tuvalu",
        UG: "Uganda",
        UA: "Ukraine",
        AE: "Forenede Arabiske Emirater",
        GB: "Storbritannien",
        US: "USA",
        UM: "USA's ydre småøer",
        UY: "Uruguay",
        UZ: "Usbekistan",
        VU: "Vanuatu",
        VE: "Venezuela",
        VN: "Vietnam",
        VG: "Britiske Jomfruøer",
        VI: "Amerikanske Jomfruøer",
        WF: "Wallis og Futuna",
        EH: "Vestsahara",
        YE: "Yemen",
        ZM: "Zambia",
        ZW: "Zimbabwe",
        AX: "Ålandsøerne",
        BQ: "Nederlandske Antiller",
        CW: "Curaçao",
        GG: "Guernsey",
        IM: "Isle of Man",
        JE: "Jersey",
        ME: "Montenegro",
        BL: "Saint-Barthélemy",
        MF: "Saint Martin (fransk side)",
        RS: "Serbien",
        SX: "Saint Martin (hollandsk side)",
        SS: "Sydsudan",
        XK: "Kosov",
    };
})(da || (da = {}));
//# sourceMappingURL=da.js.map